module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-602c1421d0024853312aa03f13a57396.png";